// @flow
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ANALYTICS_HELPER, SUPPORTED_LANG } from '../../../utils'
import { LanguagePopup } from '../../../components'
import { languageAction } from '../../../store/actions'

const languageSelected = (locale) => {
	let lang = SUPPORTED_LANG.find((language) => {
		return language.locale_switch === locale
	})

	return lang.language_icon
}

function LanguageInfo() {
	const { locale } = useSelector((state) => state.Intl)
	const dispatch = useDispatch()

	const [lang, setLang] = useState('')

	//componentDidMount
	useEffect(() => {
		/*
          SET LANGUAGE ICON
        */

		setLang(languageSelected(locale))
		// returned function will be called on component unmount
		return () => {}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const changeLanguage = () => {
		let lang_selected = SUPPORTED_LANG.find((language) => {
			return language.locale_switch === locale
		})
		dispatch(languageAction.updateLanguageLocale(lang_selected.locale))

		let htmlEl = document.querySelector('html')
		// htmlEl.setAttribute("dir", direction);
		htmlEl.setAttribute('lang', lang_selected.locale)

		// LOAD GTM EVENT
		ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
			action: ANALYTICS_HELPER.EVENT.NAVIGATION.LANG_CHANGE.ACTION,
			label: ANALYTICS_HELPER.EVENT.NAVIGATION.LANG_CHANGE.LABEL,
			properties: {
				previous: locale,
				new: lang_selected.locale,
			},
		})
	}

	return (
		<>
			<div className="dropdown d-flex languageIcon">
				<span className="nav-link" onClick={changeLanguage}>
					{lang}
				</span>
			</div>
			<LanguagePopup />
		</>
	)
}

export default LanguageInfo
